import { render, staticRenderFns } from "./u-dialog-flat-tile.vue?vue&type=template&id=7421c5e0&scoped=true"
import script from "./u-dialog-flat-tile.vue?vue&type=script&lang=js"
export * from "./u-dialog-flat-tile.vue?vue&type=script&lang=js"
import style0 from "./u-dialog-flat-tile.vue?vue&type=style&index=0&id=7421c5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7421c5e0",
  null
  
)

export default component.exports